import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { PasswordForm } from '../components/PasswordForm.tsx';
import './SettingsScreen.css';
import './PasswordScreen.css';

/**
 * «Смена пароля» — the deliberate half of the flow, reached from the settings
 * list. A push over it like the profile and theme screens, so the socket and the
 * loaded threads survive the trip and «‹» is the browser's own back.
 */
export function PasswordScreen() {
  const navigate = useNavigate();

  return (
    <div className="app-frame settings-screen">
      <header className="settings-header settings-header-divided">
        <button
          type="button"
          className="icon-button settings-back"
          onClick={() => navigate('/settings')}
          aria-label="Назад"
        >
          <ChevronLeft size={22} />
        </button>
        <h2 className="settings-heading">Смена пароля</h2>
      </header>

      <div className="settings-list">
        <div className="password-section">
          <PasswordForm askCurrent submitLabel="Сменить пароль" />
        </div>
      </div>
    </div>
  );
}
